import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Modal,
  Alert,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
function DeliveryCharge() {
  var history = useHistory();
  const sort = 25;
  const activePag = useRef(0);

  const [allCharges, setAllCharges] = useState([]);
  const [data, setData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [amount, setAmount] = useState("");
  const [minAmount, setMinAmount] = useState("");
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [testID, setTestId] = useState("");

  const [spinner, setSpinner] = useState(true);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [show1, setShow1] = useState(false);

  function getData() {
    axios
      .get(Baseurl.baseurl3 + "/health/get-health-delivery")
      .then((res) => {
        console.log("categoiryeueye", res.data.details);
        if(res.data.status){
          setAllCharges(res.data.details);
          setSearchData(res.data.details);
          setData(document.querySelectorAll("#job_data tbody tr"))
        }
        setSpinner(false);
        
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchRider(value) {
    let filteredData = [];
    searchData.map((val) => {
      if (val.Name.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setAllCharges(filteredData);
  }

  function addDeliveryCharge() {
    let deliveryField = {
        amount:amount,
        minAmount:minAmount
    };
    axios
      .post(Baseurl.baseurl3 + `/health/create-health-delivery`, deliveryField)
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  function updateCharge() {
    let testFields = {
        amount:amount,
        minAmount:minAmount
    };
    axios
      .put(
        Baseurl.baseurl3 + `/health/update-health-delivery/${testID}`,
        testFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }

  function deleteCategory() {
    axios
      .delete(
        Baseurl.baseurl3 + `/health/delete-health-delivery/${testID}`
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }

  function updateFunction(val) {
    setShow(true);
    setTestId(val._id);
    setUpdateStatus(true);
    setAmount(val.DeliveryAmount);
    setMinAmount(val.MinAmount);
  }
  return (
    <Col lg={12}>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Test</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Are You Sure You Want to Delete This Delivery Charge ?</h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              deleteCategory();
            }}
            className="btn btn-primary"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add Delivery Charge</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="row">
              <div className="col-sm-2 mt-2">
                <label>
                  Amount <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={amount}
                  type="number"
                  className="form-control"
                  placeholder="enter amount"
                  onChange={(e) => setAmount(e.target.value)}
                  required
                />
              </div>

              <div className="col-sm-2 mt-2">
                <label>
                  Minimum Amount<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={minAmount}
                  type="number"
                  className="form-control"
                  placeholder="enter min amount"
                  onChange={(e) => setMinAmount(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {updateStatus ? (
            <button
              className="btn btn-primary"
              onClick={() => {
                updateCharge();
              }}
            >
              Update
            </button>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                addDeliveryCharge();
              }}
            >
              Submit
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
          {allCharges.length===0&&(
             <button
             onClick={() => {
               setShow(true);
               setUpdateStatus(false);
               setAmount("");
               setMinAmount("");
             }}
             className="btn btn-primary"
           >
             Add Delivery Charge
           </button>
          )}
         
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>SL NO.</strong>
                    </th>

                    <th>
                      <strong>Amount</strong>
                    </th>

                    <th>
                      <strong>Minimum Amount</strong>
                    </th>

                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allCharges &&
                    allCharges.map((val, key) => (
                      <tr key={val._id}>
                        <td>{key + 1}</td>

                        <td>{val.DeliveryAmount}</td>
                        <td>{val.MinAmount}</td>

                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  updateFunction(val);
                                }}
                              >
                                Update
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setTestId(val._id);
                                  setShow1(true);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!allCharges && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero allCharges
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default DeliveryCharge;
